import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { decryptData } from 'utils/crypto';
import httpInjectorService from 'services/http-injector.service';
import ProductTour from './ProductTour';
import TourWelcomeModal from './TourWelcomeModal';

import { dashboardSteps } from '../../tours/Dashboardsteps';
import { taskSteps } from '../../tours/Tasksteps';
import { confluenceSteps } from '../../tours/Confluencesteps';
import { summarydashboardsteps } from '../../tours/SummaryDashboardSteps';
// import { companyProfileSteps } from '../../tours/steps/companyProfile.steps';
// import { employeeProfileSteps } from '../../tours/steps/employeeProfile.steps';
// import { directorySteps } from '../../tours/steps/directory.step';
// import { attendanceSteps } from '../../tours/steps/attendance.steps';
// import { leaveSteps } from '../../tours/steps/leave.steps';
// import { payrollSteps } from '../../tours/steps/payroll.step';
// import { workweekSteps } from '../../tours/steps/workweek.step';
// import { operationsSteps } from '../../tours/steps/operations.steps';
// import { announcementSteps } from '../../tours/steps/announcement.steps';
// import { profileAuditSteps } from '../../tours/steps/audit.steps';
// import { wfhSteps } from '../../tours/steps/wfh.step';

const getRouteStepsMap = (roleId) => ({
  '/admin/default': dashboardSteps(),
  '/admin/TaskManagement': taskSteps(),
  '/admin/confluence/*': confluenceSteps(),
  // '/admin/company-profile': companyProfileSteps(),
  // '/admin/my-profile': employeeProfileSteps(),
  // '/admin/directory': directorySteps(),
  // '/admin/attendance': attendanceSteps(),
  // '/admin/leaves': leaveSteps(),
  // '/admin/payroll': payrollSteps(),

  // ...(roleId === 1 || roleId === 2
  //   ? {
  //       '/admin/workweek': workweekSteps(),
  //     }
  //   : {}),

  // '/admin/operations': operationsSteps(),
  // '/admin/notifications': announcementSteps(),
  // '/admin/audit': profileAuditSteps(),
  // '/admin/wfh-request': wfhSteps(),
});

const getTourFlow = (roleId) => {
  const flow = [
    '/admin/default',
    '/admin/TaskManagement',
    '/admin/confluence/*',    // '/admin/company-profile',
    // '/admin/my-profile',
    // '/admin/directory',
    // '/admin/attendance',
    // '/admin/leaves',
    // '/admin/payroll',
    // '/admin/operations',
    // '/admin/notifications',
    // '/admin/audit',
    // '/admin/wfh-request',
  ];

  if (roleId === 1 || roleId === 2) {
    flow.splice(7, 0, '/admin/workweek');
  }

  return flow;
};

const TourProvider = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [runTour, setRunTour] = useState(false);
  const [tourSteps, setTourSteps] = useState([]);
  const [showTourModal, setShowTourModal] = useState(false);
  const roleId = Number(decryptData(Cookies.get('role_id')));

  // API call to update DB
  const updateTourStatus = async () => {
    try {
      const payload = { has_seen_tour: true };
      await httpInjectorService.updateTourStatus(payload);
    } catch (error) {
      console.error('Failed to update tour status', error);
    }
  };

  const routeStepsMap = getRouteStepsMap(roleId);
  const tourFlow = getTourFlow(roleId);


  const startTourForPage = (steps) => {
    // console.log('Starting tour');
    setTimeout(() => {
      const validSteps = steps.filter((step) => {
        const el = document.querySelector(step.target);
        return !!el;
      });
      // console.log('Valid Steps:', validSteps);
      if (validSteps.length > 0) {
        setTourSteps(validSteps);
        setRunTour(true);
      } else {
        // console.log('No targets found');
      }
    }, 1500);
  };

  useEffect(() => {
    const steps = routeStepsMap[location.pathname];

    if (!steps) return;
    const hasSeenTour = localStorage.getItem('has-seen-tour') === 'true';
    const showWelcome = sessionStorage.getItem('show-tour-welcome') === 'true';
    const autoTourRunning = sessionStorage.getItem('pulse-auto-tour') === 'true';
    const isDashboard = location.pathname === '/admin/default';
    // First Login Tour
    if (isDashboard && !hasSeenTour && !autoTourRunning) {
      setShowTourModal(true);
      return;
    }
    // Start Tour Again
    if (isDashboard && showWelcome) {
      setShowTourModal(true);
      return;
    }

    // Continue Auto Tour
    if (autoTourRunning) {
      startTourForPage(steps);
    }


  }, [location.pathname]);

  useEffect(() => {
    const restartTour = () => {

      handleStartTour();
    };

    window.addEventListener("restart-tour", restartTour);

    return () => {
      window.removeEventListener("restart-tour", restartTour);
    };
  }, []);

  const handleStartTour = async () => {

    try {
      await updateTourStatus();

      localStorage.setItem('has-seen-tour', 'true');

      sessionStorage.setItem('pulse-auto-tour', 'true');

      sessionStorage.removeItem('show-tour-welcome');

      setShowTourModal(false);


      let steps = routeStepsMap[location.pathname];

      if (!steps && location.pathname.startsWith('/admin/taskBoard/')) {
        steps = summarydashboardsteps(); // first tab tour
      }

      startTourForPage(steps);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSkipTour = async () => {
    try {
      await updateTourStatus();

      localStorage.setItem('has-seen-tour', 'true');

      sessionStorage.removeItem('pulse-auto-tour');

      sessionStorage.removeItem('show-tour-welcome');

      setShowTourModal(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleRemindLater = async () => {
    await updateTourStatus();
    // console.log('Remind Later');
    setShowTourModal(false);
  };

  const handleTourFinish = () => {
    // console.log('Page Tour Finished');

    setRunTour(false);
    setTourSteps([]);

    const currentIndex = tourFlow.indexOf(location.pathname);

    const nextPage = tourFlow[currentIndex + 1];

    if (nextPage) {
      // console.log('Navigate:', nextPage);
      navigate(nextPage);
    } else {
      // console.log('Tour Completed');

      sessionStorage.removeItem('pulse-auto-tour');
      localStorage.setItem('has-seen-tour', 'true');
    }
  };

  const handleTourClose = () => {
    setRunTour(false);
    setTourSteps([]);

    sessionStorage.removeItem('pulse-auto-tour');

    sessionStorage.removeItem('show-tour-welcome');
  };

  // console.log('runTour:', runTour);
  // console.log('tourSteps:', tourSteps.length);

  return (
    <>
      <TourWelcomeModal
        open={showTourModal}
        onStart={handleStartTour}
        onSkip={handleSkipTour}
        onRemindLater={handleRemindLater}
      />

      {tourSteps.length > 0 && (
        <ProductTour
          run={runTour}
          steps={tourSteps}
          onFinish={handleTourFinish}
          onClose={handleTourClose}
        />
      )}
    </>
  );
};

export default TourProvider;
